var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',{attrs:{"id":"inspire"}},[_c('v-app',{staticClass:"l-content",attrs:{"id":"inspire"}},[_c('MainMenu'),_c('NaviBar'),_c('v-main',[_c('Container'),_c('Footer')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }